<script>
export default {
  data() {
    return {
      toggleClass: "fa fa-fw  fa-eye field-icon",
      inputClass: "password"
    };
  },
  methods: {
    displayPassword() {
      this.toggleClass = "fa fa-fw  fa-eye field-icon blue";
      this.inputClass = "text";
    },
    hidePassword() {
      this.toggleClass = "fa fa-fw  fa-eye field-icon";
      this.inputClass = "password";
    },

    checkPassword(pwd) {
      if (pwd.length>=4) return true;
    }
  }
};
</script>



<style scoped>
.field-icon {
  margin-left: -25px;
  z-index: 2;
}
.blue {
  color: #2e75d0;
}
.demiRowIn {
  display: "inline-flex";
  width: 50%;
  margin: 5px 0px;
}
.rowIn {
  display: "inline-flex";
  width: 100%;
  margin: 5px 0px;
}
</style>